module.exports = __webpack_public_path__ + "img/cook.03fafdf5.svg";